import { Pipe, PipeTransform } from '@angular/core';
import { fileSize } from './_humanize';

@Pipe({
  name: 'sgFileSize',
  standalone: false,
})
export class SgHumanFileSizePipe implements PipeTransform {
  /**
   * Converts number of bits to a human readable form, e.g. 10024 -> 1kb
   * @param value The number of bits to convert
   * @param precision The OUTPUT number of digists after the decimal point
   */
  transform(value: number, precision?: number): string {
    return fileSize(value, precision);
  }
}
